import React, { useEffect, useState } from 'react';
import { ConfirmAppt, LinkExpiry, GetSchedulingPhone, GetAdminSettingValue } from '../appointments/create/api';//EMR-185
import Typography from "@material-ui/core/Typography";
import { Grid, Button, makeStyles } from "@material-ui/core";

// update log
// FB 4660 BR    08/30/2021    PE - Appointment confirmation url
// FB 4831 BR    11/26/2021    Appointment Confirmation - it refreshs every sec when the page is still open.
// FB 4867 DK    12/27/2021    Added screens for Support files and Health forms upload
// EMR-185 BH    23/02/2026    disable auto confirmation when the patient clicks landing page URL


function Appointmentconfirm(props: any) {
  const [returnValue, setReturnValue] = useState("");
  const [displayMessage, setDisplayMessage] = useState("");
  const [fontColor, setFontColor] = useState("limegreen");
  const [linkExpiryData, setLinkExpiryData] = useState("");
  const [SchedulingPoneData, setSchedulingPoneData] = useState("");
  const [assisstanceMessage, setAssisstanceMessage] = useState("");

  useEffect(() => {
    onload();
  },[]); //FB 4831

  const onload = async () => {
     //EMR-185 removed the below two lines
    const linkExpiryReturnData = await LinkExpiry(props.match.params.apptId, props.match.params.licenseName);
    setLinkExpiryData(linkExpiryReturnData);
    const SchedulingPhoneReturnData = await GetSchedulingPhone(props.match.params.apptId, props.match.params.licenseName);
    setSchedulingPoneData(SchedulingPhoneReturnData);
    //EMR-185 Begin

    const defaultAppointConfirm = await GetAdminSettingValue("DefaultAppointmentConfirmation");
    let data = "";
    if (defaultAppointConfirm == "1") {
      data = await ConfirmAppt(props.match.params.apptId, props.match.params.licenseName);
    }
    setReturnValue(data);
    //EMR-185 End

    if (data == "Appointment is cancelled") { //FB 4831
      setDisplayMessage("Your appointment is cancelled");
      setAssisstanceMessage("For further assistance please call:" + SchedulingPhoneReturnData); //FB 4831
      setFontColor("red");
    } else {
      if (linkExpiryReturnData == "Appointment is in the past") {   //4867
        setDisplayMessage("Your appointment date is already passed.");
        setAssisstanceMessage("For further assistance please call:" + SchedulingPhoneReturnData); //FB 4831
        setFontColor("red");
      } else {
        //EMR-185 begin
        if (defaultAppointConfirm != "1") {
          setDisplayMessage("");
        } else if (data == "Appointment is confirmed") { //FB 4831
          //EMR   185 End
          setDisplayMessage("Your appointment is confirmed.");
          setAssisstanceMessage("");
          setFontColor("limegreen");
        }
        else {
          setDisplayMessage("There was an error confirming your appointment.");
          setAssisstanceMessage("For further assistance please call:" + SchedulingPhoneReturnData); //FB 4831
          setFontColor("red");
        }
      }

    }


  }
  const useStyles = makeStyles({
    active: {
      backgroundColor: "#18a2b8",
      color: "white",
      textTransform: "capitalize",
      borderRadius: "15px",
      marginLeft: "20px",
      "&:hover": {
        backgroundColor: "#18a2b8",
      },
    },
  });

  const classes = useStyles();

  return (
    <div>
      <Grid
        lg={12}
        md={12}
        sm={12}
        xs={12}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "2%"
        }}
      >
        {/* <Box component="fieldset" mb={12} style={{display: "flex", alignItems: "center",justifyContent:"center"}} borderColor="transparent"> */}
        <Typography variant="h5" style={{ color: fontColor }} component="legend">
          <br></br>
          {displayMessage}
          <br></br>
          {assisstanceMessage}

        </Typography>
        {/* </Box> */}

      </Grid>
    </div>
  );



}
export default Appointmentconfirm;